Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = require('./dist/components/IngestProvider').default;
exports.ccxController = require('./dist/controllers/IngestController').default;
exports.ccxIngest = require('./dist/decorators/ccxIngest').default;
exports.ccxIngestContext = require('./dist/context').IngestContext;
exports.useCCXIngest = require('./dist/hooks/useCCXIngest').default;
